module.exports = __webpack_public_path__ + "img/icon_window_down@3x.73c29b95.png";